import { Grid, Typography, styled } from "@mui/material";
import clsx from "clsx";
import styles from "./ImageError.module.scss";
import WarningAlertIcon from "../../../assets/images/icons/WarningAlertIcon.tsx";

interface TitleProps {
	titleFontSize: string;
}

interface TextProps {
	massageTextSize: string;
	messageColor?: string;
}

const Title = styled("div")<TitleProps>(({ titleFontSize }) => ({
	fontWeight: 600,
	fontSize: titleFontSize,
	color: "#A4A4A4",
}));

const Text = styled(Typography)<TextProps>(({ massageTextSize, messageColor }) => ({
	color: messageColor ? messageColor : "#A4A4A4",
	textAlign: "center",
	lineHeight: "normal",
	margin: "0 15% 0 15%",
	fontSize: massageTextSize,
}));

export default function ImageError({
	imageWidth,
	imageHeight,
	massageText,
	titleText,
	titleFontSize,
	largeSvg = false,
	warningSvg = false,
	massageTextSize,
}: {
	imageWidth: string;
	imageHeight: string;
	massageText: string;
	titleText: string;
	titleFontSize: string;
	largeSvg?: boolean;
	warningSvg?: boolean;
	massageTextSize: string;
}) {
	const backgroundClass = warningSvg
		? styles.warningBackground
		: largeSvg
		? styles.solidBackground
		: styles.defaultBackground;

	const getIcon = () => {
		if (warningSvg) return <WarningAlertIcon className={styles.warningIcon} width={50} height={50} />;

		return largeSvg ? (
			<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM22 30H18V26H22V30ZM22 22H18V10H22V22Z"
					fill="#A4A4A4"
				/>
			</svg>
		) : (
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.8 12H7.2V10.4H8.8V12ZM8.8 8.8H7.2V4H8.8V8.8Z"
					fill="#A4A4A4"
				/>
			</svg>
		);
	};

	return (
		<Grid
			container
			className={`${styles.imageErrorContainer} ${backgroundClass}`}
			sx={{ width: imageWidth, height: imageHeight }}
		>
			<Grid xs={12}>
				<Grid item xs={12}>
					{getIcon()}
				</Grid>
				<Grid item xs={12}>
					<Title as="h1" titleFontSize={titleFontSize} className={styles.title}>
						{titleText}
					</Title>

					{massageText && (
						<Text
							massageTextSize={massageTextSize}
							messageColor={warningSvg ? "#000" : undefined}
							className={clsx({ [styles.title]: warningSvg })}
						>
							{massageText}
						</Text>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
